/**
 * @file
 * @fileOverview This file contains the AframeVideoJs class for handling A-Frame video playback with Video.js.
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

import videojs from 'video.js';
import 'videojs-youtube';

class AframeVideoJs {
  constructor(videoId, isYouTube = true) {
    this.isYouTube = isYouTube;
    this.videoId = videoId;
    this.initVideoElement();
    this.initPlayer();
  }

  initVideoElement() {
    this.videoElement = document.createElement('video');
    this.videoElement.id = 'my-video';
    this.videoElement.className = 'video-js vjs-default-skin';
    this.videoElement.style.display = 'none';
    document.body.appendChild(this.videoElement);
  }

  initPlayer() {
    const sources = this.isYouTube
      ? [{ type: 'video/youtube', src: `https://www.youtube.com/watch?v=${this.videoId}` }]
      : [{ type: 'video/mp4', src: this.videoId }];

    this.player = videojs('my-video', {
      techOrder: this.isYouTube ? ['youtube'] : ['html5'],
      sources: sources
    });

    this.player.ready(() => {
      this.setupAframeVideo();
    });
  }

  setupAframeVideo() {
    this.aframeVideo = document.createElement('video');
    this.aframeVideo.id = 'videoTexture';
    this.aframeVideo.setAttribute('autoplay', 'true');
    this.aframeVideo.setAttribute('loop', 'true');
    this.aframeVideo.setAttribute('crossorigin', 'anonymous');
    this.aframeVideo.setAttribute('webkit-playsinline', 'true');
    this.aframeVideo.setAttribute('playsinline', 'true');
    document.querySelector('a-assets').appendChild(this.aframeVideo);

    this.player.on('play', () => {
      this.aframeVideo.src = this.videoElement.querySelector('source').src;
      this.aframeVideo.play();
    });
  }

  changeVideo(newVideoId, isYouTube = true) {
    this.isYouTube = isYouTube;
    const newSource = isYouTube
      ? { type: 'video/youtube', src: `https://www.youtube.com/watch?v=${newVideoId}` }
      : { type: 'video/mp4', src: newVideoId };

    this.videoId = newVideoId;
    this.player.src(newSource);
    this.player.play();
  }
}

export default AframeVideoJs;
